export default __webpack_public_path__ + "static/media/IMG2.719f4e73.png";